var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCaretWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3 8.5a.502.502 0 01.854-.354L11 15.293l7.146-7.147a.502.502 0 01.708.708L11 16.707 3.146 8.854A.502.502 0 013 8.5"
  })));
}

export default __webpack_public_path__ + "1f0c844b6a0f89f6a933c6a7f9b880d2.svg";
export { SvgIconCaretWhite as ReactComponent };